<template>
  <div class="custom-dropdown" @click="openDropdown">
    <img
      src="@/assets/images/icons/v3-angledown.svg"
      alt="#"
      class="angledown"
      v-if="theme == 'light'"
    />
     <img
      src="@/assets/images/icons/angle-down-td.svg"
      alt="#"
      class="angledown"
      v-if="theme == 'medium'"
    />
    <img
      src="@/assets/images/icons/angle-down-td.svg"
      alt="#"
      class="angledown"
      v-if="theme == 'dark'"
    />
    <span v-if="lang == 'ar'">عربى</span>
    <span v-if="lang == 'en'">English</span>

    <div class="lang-toggler" v-if="isVisible">
      <ul>
        <li @click="changeLang('en')">
          <a href="javascript:void(0)">English</a>
        </li>
        <li @click="changeLang('ar')">
          <a href="javascript:void(0)">عربى</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import store from "@/store";
export default {
  name: "LangTogglerV3",
  data() {
    return {
      isVisible: false,
    };
  },
  computed: {
    
      theme() {
          return store.getters.getCurrentTheme
      },
      lang() {
        return store.getters.getCurrentLang
      }
  },
  methods: {
    openDropdown: function() {
        this.isVisible = !this.isVisible;
    },
    changeLang: function (lang) {
      if (lang != this.lang) {
        store.dispatch("setLang", lang);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";
// Arabic Css
body.theme-light.ar {
  .custom-dropdown {
    width: 83px;
    height: 33px;
    border: 1px solid #153E39;
    border-radius: 16.5px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-left: 15px;
    padding-bottom: 3px;
    position: relative;
    cursor: pointer;

    span {
      @include apply-font($almarai, 700, 15px, #153E39);
    }
    .align {
      position: absolute;
      left: 20px;
    }
    .angledown {
      position: absolute;
      right: 15px;
      top: 12px;
    }
  }
  .lang-toggler {
    width: 145px;
    height: 75px;
    background: rgba(224, 224, 224, 0.24);
    backdrop-filter: blur(128px);
    border-radius: 15px;
    position: absolute;
    top: 40px;
    left: 0;
    z-index: 20;
    padding: 10px 0px;
    ul {
      padding: 0;
      margin: 0;
      li {
        list-style: none;
        text-indent: 15px;
        height: 28px;

        a {
          @include remove-anchor-defaults;
          @include apply-font($almarai, 400, 14px, #000);
        }
      }
       li:hover {
        background: rgba(0,0,0,0.34);
      }
    }
  }
}
body.theme-medium.ar {
  .custom-dropdown {
    width: 83px;
    height: 33px;
    border: 1px solid #fff;
    border-radius: 16.5px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-left: 15px;
    padding-bottom: 3px;
    position: relative;
    cursor: pointer;

    span {
      @include apply-font($almarai, 700, 15px, #fff);
    }
    .align {
      position: absolute;
      left: 20px;
    }
    .angledown {
      position: absolute;
      right: 15px;
      top: 12px;
      color: #fff;
    }
  }
  .lang-toggler {
    width: 145px;
    height: 75px;
    background: rgba(224, 224, 224, 0.24);
    backdrop-filter: blur(128px);
    border-radius: 15px;
    position: absolute;
    top: 40px;
    left: 0;
    z-index: 20;
    padding: 10px 0px;
    ul {
      padding: 0;
      margin: 0;
      li {
        list-style: none;
        text-indent: 15px;
        height: 28px;

        a {
          @include remove-anchor-defaults;
          @include apply-font($almarai, 400, 14px, #fff);
        }
      }
       li:hover {
        background: rgba(0,0,0,0.34);
      }
    }
  }
}
body.theme-dark.ar {
  .custom-dropdown {
    width: 83px;
    height: 33px;
    // background: linear-gradient(180deg, #2A3435 0%, #455658 102.02%);
    border: 1px solid #2A3944;
    border-radius: 16.5px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-left: 15px;
    padding-bottom: 3px;
    position: relative;
    cursor: pointer;

    span {
      @include apply-font($almarai, 700, 15px, #fff);
    }
    .align {
      position: absolute;
      left: 20px;
    }
    .angledown {
      position: absolute;
      right: 15px;
      top: 12px;
      color: #fff;
    }
  }
  .lang-toggler {
    width: 145px;
    height: 75px;
    background: rgba(224, 224, 224, 0.24);
    backdrop-filter: blur(128px);
    border-radius: 15px;
    position: absolute;
    top: 40px;
    left: 0;
    z-index: 20;
    padding: 10px 0px;
    ul {
      padding: 0;
      margin: 0;
      li {
        list-style: none;
        text-indent: 15px;
        height: 28px;
        a {
          @include remove-anchor-defaults;
          @include apply-font($almarai, 400, 14px, #fff);
        }
      }
      li:hover {
        background: rgba(0,0,0,0.34);
      }
    }
  }
}

// English Css
body.theme-light.en {
  .custom-dropdown {
    width: 93px;
    height: 33px;
    border: 1px solid #153E39;
    border-radius: 16.5px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 10px;
    padding-bottom: 0px;
    position: relative;
    cursor: pointer;

    span {
      @include apply-font($sourcesanspro, 700, 15px, #153E39);
    }
    .align {
      position: absolute;
      left: 20px;
    }
    .angledown {
      position: absolute;
      right: 10px;
      top: 12px;
    }
  }
  .lang-toggler {
    width: 145px;
    height: 75px;
    background: rgba(224, 224, 224, 0.24);
    backdrop-filter: blur(128px);
    border-radius: 15px;
    position: absolute;
    top: 40px;
    left: 0;
    z-index: 20;
    padding: 10px 0px;
    ul {
      padding: 0;
      margin: 0;
      li {
        list-style: none;
        text-indent: 15px;
        height: 28px;

        a {
          @include remove-anchor-defaults;
          @include apply-font($almarai, 400, 14px, #000);
        }
      }
       li:hover {
        background: rgba(0,0,0,0.34);
      }
    }
  }
}
body.theme-medium.en {
  .custom-dropdown {
    width: 93px;
    height: 33px;
    border: 1px solid #fff;
    border-radius: 16.5px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 10px;
    padding-bottom: 0px;
    position: relative;
    cursor: pointer;

    span {
      @include apply-font($sourcesanspro, 700, 15px, #fff);
    }
    .align {
      position: absolute;
      left: 20px;
    }
    .angledown {
      position: absolute;
      right: 10px;
      top: 12px;
      color: #fff;
    }
  }
  .lang-toggler {
    width: 145px;
    height: 75px;
    background: rgba(224, 224, 224, 0.24);
    backdrop-filter: blur(128px);
    border-radius: 15px;
    position: absolute;
    top: 40px;
    left: 0;
    z-index: 20;
    padding: 10px 0px;
    ul {
      padding: 0;
      margin: 0;
      li {
        list-style: none;
        text-indent: 15px;
        height: 28px;
        a {
          @include remove-anchor-defaults;
          @include apply-font($almarai, 400, 14px, #fff);
        }
      }
       li:hover {
        background: rgba(0,0,0,0.34);
      }
    }
  }
}
body.theme-dark.en {
  .custom-dropdown {
    width: 93px;
    height: 33px;
    border: 1px solid #2A3944;
    border-radius: 16.5px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 10px;
    padding-bottom: 0px;
    position: relative;
    cursor: pointer;

    span {
      @include apply-font($sourcesanspro, 700, 15px, #fff);
    }
    .align {
      position: absolute;
      left: 20px;
    }
    .angledown {
      position: absolute;
      right: 10px;
      top: 12px;
      color: #fff;
    }
  }
  .lang-toggler {
    width: 145px;
    height: 75px;
    background: rgba(224, 224, 224, 0.24);
    backdrop-filter: blur(128px);
    border-radius: 15px;
    position: absolute;
    top: 40px;
    left: 0;
    z-index: 20;
    padding: 10px 0px;
    ul {
      padding: 0;
      margin: 0;
      li {
        list-style: none;
        text-indent: 15px;
        height: 28px;

        a {
          @include remove-anchor-defaults;
          @include apply-font($almarai, 400, 14px, #fff);
        }
      }
       li:hover {
        background: rgba(0,0,0,0.34);
      }
    }
  }
}
</style>